import React from 'react'
import { Link } from 'react-router-dom'

function Program() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Program</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Programs Start --> */}
    <section className="section-padding">
        <div className="container">
        <div className="row">
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/1.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Chest Workout</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/2.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Cardio Training</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/3.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Legpress or Squat</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
              
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/4.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Our Instructor</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <nav>
                        <ul className="pagination">
                            <li className="page-item">
                                <Link className="page-link" to="#">
                                    Previous
                                </Link>
                            </li>
                            <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                            <li className="page-item">
                                <Link className="page-link" to="#">
                                    Next
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Programs End -->
    <!-- Offer Start --> */}
    <section className="bg-white">
        <div className="container-fluid p-0">
            <div className="row g-0 justify-content-between align-items-center">
                <div className="col-lg-5 d-none d-lg-block">
                    <img src="/tm/react/fit2fine/assets/images/bg/bg_2.png" alt="img" className="image-fit"/>
                </div>
                <div className="col-lg-6">
                    <div className="section mask-image contain" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_3.png)' }}>
                        <div className="offer_text">
                            <h3 className="subtitle">Open</h3>
                            <h2 className="title">Training</h2>
                            <h3 className="action">Free In Your <Link to="/contact">Fitness Spot</Link></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Offer End -->
    <!-- Team Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="section-header">
                <h3 className="title">Our <span> Team</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row">
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Frsixa Deam</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
             
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Alexa Nairo</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Merica Haric</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/4.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Steve Cross</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Program